module.exports = __webpack_public_path__ + "static/img/lapp.539056d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/lapp.png
// module id = 495
// module chunks = 1